import BaseService from '../baseServices';
import REST from '../../configs/rest';

function getClassificationsReport(params) {
  let q = '';
  if (params?.start_date && params?.end_date) {
    q = `?start_date=${params?.start_date}&end_date=${params?.end_date}`;
  }
  return BaseService.get(`${REST.REPORT_CLASSIFICATION}${q}`);
}

function getDepartmentsReport(params) {
  let q = '';
  if (params?.start_date && params?.end_date) {
    q = `?start_date=${params?.start_date}&end_date=${params?.end_date}`;
  }
  return BaseService.get(`${REST.REPORT_DEPARTMENT}${q}`);
}

function getGradeReport(params) {
  let q = '';
  if (params?.start_date && params?.end_date) {
    q = `?start_date=${params?.start_date}&end_date=${params?.end_date}`;
  }
  return BaseService.get(`${REST.REPORT_GRADE}${q}`);
}

function getEmployeeExpire(params) {
  let q = '';
  if (params?.start_date && params?.end_date) {
    q = `?start_date=${params?.start_date}&end_date=${params?.end_date}`;
  }
  return BaseService.get(`${REST.REPORT_EMPLOYEE_EXPIRE}${q}`);
}

function getEmployee(params) {
  let q = '';
  if (params?.start_date && params?.end_date) {
    q = `?start_date=${params?.start_date}&end_date=${params?.end_date}`;
  }
  return BaseService.get(`${REST.REPORT_EMPLOYEE}${q}`);
}

function getEmployeeDepartments(params) {
  let q = '';
  if (params?.start_date && params?.end_date) {
    q = `?start_date=${params?.start_date}&end_date=${params?.end_date}`;
  }
  return BaseService.get(`${REST.REPORT_EMPLOYEE_DEPARTMENT}${q}`);
}

function getEmployeeGrade(params) {
  let q = '';
  if (params?.start_date && params?.end_date) {
    q = `?start_date=${params?.start_date}&end_date=${params?.end_date}`;
  }
  return BaseService.get(`${REST.REPORT_EMPLOYEE_GRADE}${q}`);
}

function getEmployeeClassification(params) {
  let q = '';
  if (params?.start_date && params?.end_date) {
    q = `?start_date=${params?.start_date}&end_date=${params?.end_date}`;
  }
  return BaseService.get(`${REST.REPORT_EMPLOYEE_CLASSIFICATION}${q}`);
}

export default {
  getGradeReport,
  getDepartmentsReport,
  getClassificationsReport,
  getEmployeeExpire,
  getEmployee,
  getEmployeeDepartments,
  getEmployeeGrade,
  getEmployeeClassification,
};
